import config from "@utils/config";
import { useSafeAreaInsets } from "react-native-safe-area-context";

export const useTopBarHeight = () => {
  const { top } = useSafeAreaInsets();
  return top + config.UI.topBarHeight;
};
